/**
****************************************************************************************
Project: Readabl
File: Header.js
Description: This file will render header portion for PDFViewer component.
© Healthcare Triangle, Inc
****************************************************************************************
**/

import React, { useEffect, useRef } from "react";
import { FileDownload, SelectAll, Close, Rotate90DegreesCcw, Print, Menu } from "@mui/icons-material";
import { saveAs } from 'file-saver';
import { PageNumberComponent, SearchComponent, ZoomComponent } from ".";

const Header = (props) => {

    const headerContainerRef = useRef(null);
    
    return <div className="pdf-viewer-header-container" ref={headerContainerRef}>

        <div className="header-left-content">
            <Menu onClick={props.handleThumbnailMenuClick}/>
            <div className="pdf-viewer-header-title">{props.fileName}</div>
        </div>
        {props.images?.length ? <>
            <div style={{ display: "flex", alignItems: "center" }}>
                <PageNumberComponent total={props.totalPages} currentPage={props.currentPageNumber} />
                <span className="pdf-viewer-header-options-splitter">|</span>
                <ZoomComponent disabled={props.enableSelection} zoomLevel={props.zoomLevel} handleZoom={val => !props.enableSelection && props.updateZoom(val)} />
                <span className="pdf-viewer-header-options-splitter">|</span>
                {!props.disableRotate && <>
                    <Rotate90DegreesCcw sx={{ ":hover": { cursor: "pointer", } }} onClick={ props.handleRotate} />
                    <span className="pdf-viewer-header-options-splitter">|</span>
                </>}
                <FileDownload style={{ fill: "#fff", cursor: "pointer" }} onClick={e => {
                    saveAs(props.pdfUrl, props.fileName)
                }} />
                <Print style={{ fill: "#fff", cursor: "pointer", marginLeft: "20px" }} onClick={props.handlePrint }/>
                {!props.disableRotate && props.showSelection != false && <span className="pdf-viewer-header-options-splitter">|</span> || null}
                {!props.disableRotate && props.showSelection != false && (!props.enableSelection ? <SelectAll
                    style={{ cursor: "pointer" }}
                    onClick={props.enableSelectionLayers} /> : <span
                        style={{ display: "flex", alignItems: "center", width: "max-content" }}>
                    <Close onClick={props.enableSelectionLayers} style={{ marginRight: "10px", marginTop: "3px", cursor: "pointer" }} />
                    {props.selectedPages?.length} selected
                </span>) || null}
            </div>
            {props.showSearch != false && <SearchComponent 
                displaySearchText={props.displaySearchText} 
                handleSearch={props.handleSearch} 
                searchResults={props.searchResults} 
                onSearchClose={props.onSearchClose}
                searchString={props.searchString}
                pdfUrl={props.pdfUrl}
            /> || null}
            {props.showSelection == false && props.showSearch == false && <div></div> || null}
        </> : null}
    </div>
}

export default Header;